import React from "react";
import classNames from "classnames";

const Field = ({ children, className }) => (
  <div className={classNames("section__wrapper--field", className)}>
    {children}
  </div>
);

export default Field;
